export default "__VITE_ASSET__ac9fc9a3__"